import { useEffect, useState } from "react";
import { Menu, X } from "lucide-react";
import { NAV, SITE } from "../data/content";

export const Header = () => {
    const [scrolled, setScrolled] = useState(false);
    const [open, setOpen] = useState(false);

    useEffect(() => {
        const onScroll = () => setScrolled(window.scrollY > 8);
        onScroll();
        window.addEventListener("scroll", onScroll, { passive: true });
        return () => window.removeEventListener("scroll", onScroll);
    }, []);

    return (
        <header
            data-testid="site-header"
            className={`fixed top-0 inset-x-0 z-50 bg-white/95 backdrop-blur-md border-b border-bh-green/10 transition-shadow duration-300 ${
                scrolled ? "shadow-[0_8px_30px_rgba(6,76,61,0.08)]" : ""
            }`}
        >
            <div className="max-w-[1565px] mx-auto px-5 sm:px-8 h-[76px] flex items-center justify-between gap-4">
                <a
                    href="#beranda"
                    data-testid="header-logo-link"
                    className="flex items-center gap-3 shrink-0"
                    aria-label="PPTQ Baitul Haq Trenggalek — Halaman Utama"
                >
                    <img
                        src="/assets/logo-web.png"
                        alt="Logo resmi PPTQ Baitul Haq"
                        className="h-12 w-auto"
                        width="48"
                        height="48"
                    />
                    <span className="hidden xl:block leading-tight">
                        <span className="block text-sm font-bold text-bh-deep tracking-wide">
                            {SITE.fullName}
                        </span>
                        <span className="block text-[11px] text-bh-gray">
                            {SITE.subtitle}
                        </span>
                    </span>
                </a>

                <nav aria-label="Navigasi utama" className="hidden lg:block">
                    <ul className="flex items-center gap-7">
                        {NAV.map((item) => (
                            <li key={item.id}>
                                <a
                                    href={item.href}
                                    data-testid={`nav-link-${item.id}`}
                                    className="whitespace-nowrap text-[13px] font-semibold uppercase tracking-[0.12em] text-bh-ink/80 hover:text-bh-green transition-colors duration-200"
                                >
                                    {item.label}
                                </a>
                            </li>
                        ))}
                    </ul>
                </nav>

                <div className="flex items-center gap-3">
                    <a
                        href="#daftar"
                        data-testid="header-cta-daftar"
                        className="inline-flex items-center justify-center whitespace-nowrap rounded-full bg-bh-green px-5 py-2.5 text-[13px] font-bold uppercase tracking-[0.1em] text-white transition-colors duration-200 hover:bg-bh-dark"
                    >
                        Daftar Sekarang
                    </a>
                    <button
                        type="button"
                        data-testid="mobile-menu-toggle"
                        aria-label={open ? "Tutup menu navigasi" : "Buka menu navigasi"}
                        aria-expanded={open}
                        onClick={() => setOpen((v) => !v)}
                        className="lg:hidden inline-flex items-center justify-center w-11 h-11 rounded-full border border-bh-green/20 text-bh-deep"
                    >
                        {open ? <X className="w-5 h-5" /> : <Menu className="w-5 h-5" />}
                    </button>
                </div>
            </div>

            {open && (
                <nav
                    aria-label="Navigasi mobile"
                    data-testid="mobile-nav"
                    className="lg:hidden border-t border-bh-green/10 bg-white"
                >
                    <ul className="px-5 py-4 space-y-1">
                        {NAV.map((item) => (
                            <li key={item.id}>
                                <a
                                    href={item.href}
                                    data-testid={`mobile-nav-link-${item.id}`}
                                    onClick={() => setOpen(false)}
                                    className="block py-3 text-sm font-semibold uppercase tracking-[0.12em] text-bh-ink/85 hover:text-bh-green"
                                >
                                    {item.label}
                                </a>
                            </li>
                        ))}
                    </ul>
                </nav>
            )}
        </header>
    );
};
